import { useEffect } from 'react';
import { JobRecuruitPrImageResponse } from '@doda/api-client/aspida/@types';

/**
 * Pickupコンテンツを取得するhook
 * @param root0
 */
export const useGetPickupContents = ({
  recruitPrImage,
}: {
  recruitPrImage: JobRecuruitPrImageResponse | undefined;
}) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: ライブラリーの型インストールする
    import('image-map-resizer').then((module) => {
      return module.default();
    });
  }, []);

  // mapタグを取得
  const mapTags = recruitPrImage?.imageHTML
    ?.match(/<map\s(.|\r|\n|<\/map>)*?<\/map>/g)
    ?.join();

  // imgタグからusemapの値を取得
  const usemapNameList =
    recruitPrImage?.imageHTML
      ?.match(/<img\s(.|\r|\n|\/>)*?\/>/g)
      ?.map(
        (imgHref) =>
          imgHref.match(/usemap="(?<name>(.|\r|\n)*?)"/)?.groups?.name
      ) || [];

  return { mapTags, usemapNameList };
};
